import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainRoutes from "./routes/MainRoutes";
import { AuthProvider } from "./hooks/useAuth";
import { PathProvider } from "./hooks/usePath"; // Import PathProvider
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "assets/css/swal.css";
import "antd/dist/reset.css"; // This might be required instead of 'antd/dist/antd.css' for newer versions
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Define your theme
const theme = createTheme({
  typography: {
    fontFamily: "Prompt, sans-serif", // Change to your desired font family
    h6: {
      fontSize: "1.25rem", // Change to your desired font size for h6
      fontWeight: 600, // Example: you can use any of the defined font weights
      fontStyle: "normal", // Example: you can use "italic" for italicized style
    },
    body1: {
      fontSize: "1rem", // Change to your desired font size for body1
      fontWeight: 400, // Example: you can use any of the defined font weights
      fontStyle: "normal", // Example: you can use "italic" for italicized style
    },
    // Add more typography variants as needed
    // 0.063 rem = 1 px | 4 px = 0.25rem
  },
});

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <PathProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
              <Routes>
                <Route path="/*" element={<MainRoutes />} />
              </Routes>
            </Router>
          </ThemeProvider>
        </PathProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
